import BaseMygocuApiService from './BaseMygocuApiService';

const HOME_API_VERSION = 'v1';
const HOME_API_BASEPATH_URL = '/home/' + HOME_API_VERSION;

class HomeApiService {
  async getAgencia() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/agencia'));
  }

  async getEsponsors() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/esponsors'));
  }

  async getVideos() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/videos'));
  }

  async getFaqs() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/faqs'));
  }

  async sendTrabajaConNosotrosCv(trabajaConNosotros) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat('/trabajaNosotrosCv'), trabajaConNosotros, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async getAlojamiento(idAlojamiento) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat(`/alojamiento/${idAlojamiento}`));
  }

  async getAlojamientoSeo(idAlojamiento) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat(`/alojamiento/${idAlojamiento}/seo`));
  }

  async getBlogFilters() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/blogs/filtros'));
  }

  async getBlog() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/blog'));
  }

  async getBlogByUri(uri) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/blog/' + uri));
  }

  async getBlogByUriSeo(uri) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/blog/' + uri + '/seo'));
  }

  async getApresSkis() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/apresSkis'));
  }

  async getApresSkisHeader() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/apresSkis/header'));
  }

  async getApresSkiById(idApresSki) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/apresSkis/' + idApresSki));
  }

  async getApresSkiByIdSEO(idApresSki) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/apresSkis/' + idApresSki + '/seo'));
  }

  async getLegalNotice() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/legalNotice'));
  }

  async getTermsConditions() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/termsConditions'));
  }

  async getCookiePolicy() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/cookiePolicy'));
  }

  async getPrivacyPolicy() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/privacyPolicy'));
  }
}

export default new HomeApiService();
